Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Reviews = Marionette.Behavior.extend({
        ui: {
            imageHolder: '.img_holder',
            accesibilityImage: 'img',
            textReview: '.text_review_holder',
            reviewContent: '.text_review',
            reviewerName: '.reviewer_name',
            starHolder: '.star_holder'
        },
        onShow: function() {
            this.reviewOptions = gon.display_options.reviewOptions || {};
            if (this.reviewOptions.displayReviews) {
                this.markAsReview();
                this.updatePhotoReviewInfo();
            }
        },
        reviewReducer: function(reviewAccumulator, currProd) {
            return reviewAccumulator + currProd['reviews'].length;
        },
        hasReviews: function() {
            var products = this.view.model.get('products');

            //we should never assign the review class to a photo that has no corresponding reviews
            if (products.length) {
                //create an array of all the reviews_info objects for each product assigned to this photo
                var reviews = _.pluck(products, 'reviews_info');

                //todo: remove the reviews[0] check after we go live, it's only for initial push cache issues
                //find the total number of reviews between all of the products
                var numReviews = reviews[0] ? reviews.reduce(this.reviewReducer, 0) : 0;

                //return verdict on whether it's a valid candidate for the review class
                return numReviews > 0 && !_.isFalsy(this.ui.textReview.data('review-id'));
            }

            return;
        },
        isAdjacent: function(photosSinceLastReview) {
            var imageWidth = this.ui.imageHolder.width();
            var widgetWidth = $('#widget').width();
            var rowLength = Math.floor(widgetWidth / imageWidth);

            //if it's mod 0 the length of the row then they're vertically adjacent
            return (rowLength % photosSinceLastReview) === 0;
        },
        convertToReviewTile: function() {
            var productImage = this.ui.accesibilityImage.attr('data-prod-image');

            productImage = App.request('decode:utf8', productImage);

            //we flip the image to the product one (which is already stored in dom) and add a css class
            this.view.$el.addClass('active_review');
            this.ui.imageHolder.css('background-image', 'url(' + productImage + ')');
            this.ui.accesibilityImage.attr('src', productImage);
        },
        markAsReview: function() {
            var photoCollection = this.view.model.collection;
            var reviewSelectionOptions = photoCollection.reviewSelectionOptions;
            var frequency = this.reviewOptions.frequency || 0.35; // percentage of gallery that should be reviews
            var gallerySize = photoCollection.perPage || 15; // number of photos that render in the gallery on load

            //LEAVING ALL THESE CONSOLE LOGS INTENTIONALLY COMMENTED DURING OUR CUSTOMER VALIDATION TESTING

            // console.log('\n');
            // console.log("gallery size: " + gallerySize);

            //(1) figure out how many photos should be reviews, and what the average gap should be
            var estimatedTotalReviews = gallerySize * frequency;
            var averageReviewGap = Math.floor(gallerySize / estimatedTotalReviews);

            //(2) generate some random number (divide by 2 to increase frequency, necessary from testing)
            var randomNumber = Math.random() / 2;
            var gapSkew = 0.2; // percentage to skew the gap between photos by

            //(3) calculate the allowed range within which the next review can appear
            var photosSinceLastReview = reviewSelectionOptions.lastSet !== undefined ? reviewSelectionOptions.currentModelIndex - reviewSelectionOptions.lastSet : 0;
            var allowedRange = Math.abs(averageReviewGap - reviewSelectionOptions.gapNoise);

            // console.log("photos since last: " + photosSinceLastReview);
            // console.log("allowed range: " + allowedRange);

            //(4) A photo will become a review if it is both eligible, and randomly selected within the given frequency
            var hasReviews = this.hasReviews();
            var isAdjacent = this.isAdjacent(photosSinceLastReview);
            var isEligible = photosSinceLastReview ? photosSinceLastReview > allowedRange && !isAdjacent : true;
            var isMosaic = gon.type === 'mosaic_v2' || (gon.type === 'carousel' && gon.display_options.carouselOptions.layout === 'mosaic');
            var isMobileSmallTile = isMosaic && gon.isMobile && this.view.model.get('elementSize') === 'small';
            var isReview = hasReviews && isEligible && randomNumber <= frequency && !isMobileSmallTile;

            // console.log("is eligible: " + isEligible);
            // console.log("is review: " + isReview);

            //(5) If the photo was selected as a review, apply css accordingly, and alter the noise to prevent uniformity
            if (isReview) {
                this.convertToReviewTile();
                reviewSelectionOptions.lastSet = reviewSelectionOptions.currentModelIndex;
                reviewSelectionOptions.gapNoise = Math.ceil(estimatedTotalReviews * gapSkew);
            } else {
                reviewSelectionOptions.gapNoise = 0; //reset noise
            }
            reviewSelectionOptions.currentModelIndex++;
        },
        updatePhotoReviewInfo: function() {
            this.view.model.set('selectedReviewInfo', {
                id: this.ui.textReview.data('review-id'),
                title: this.ui.reviewContent.data('title'),
                content: this.ui.reviewContent.text().trim(),
                rating: this.ui.starHolder.data('score'),
                user_name: this.ui.reviewerName.text().trim(),
                active: this.$el.hasClass('active_review')
            });
        }
    });

});